import type React from "react";
import {
  ChartContainer as ShadcnChartContainer,
  ChartTooltip as ShadcnChartTooltip,
  ChartTooltipContent as ShadcnChartTooltipContent,
  ChartLegend as ShadcnChartLegend,
  ChartLegendContent as ShadcnChartLegendContent,
  ChartStyle as ShadcnChartStyle,
} from "src/shadcn/components/chart";

const ChartContainer = (
  props: React.ComponentProps<typeof ShadcnChartContainer>
) => <ShadcnChartContainer {...props} />;

const ChartTooltip = (
  props: React.ComponentProps<typeof ShadcnChartTooltip>
) => <ShadcnChartTooltip {...props} />;

const ChartTooltipContent = (
  props: React.ComponentProps<typeof ShadcnChartTooltipContent>
) => <ShadcnChartTooltipContent {...props} />;

const ChartLegend = (props: React.ComponentProps<typeof ShadcnChartLegend>) => (
  <ShadcnChartLegend {...props} />
);

const ChartLegendContent = (
  props: React.ComponentProps<typeof ShadcnChartLegendContent>
) => <ShadcnChartLegendContent {...props} />;

const ChartStyle = (props: React.ComponentProps<typeof ShadcnChartStyle>) => (
  <ShadcnChartStyle {...props} />
);

export {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  ChartLegend,
  ChartLegendContent,
  ChartStyle,
};
export type { ChartConfig } from "src/shadcn/components/chart";
